import { useEffect, useState } from "react";

const Skills = () => {
  const [expertise, setExpertise] = useState([]);

  useEffect(() => {
    fetch("expertise.json")
      .then((res) => res.json())
      .then((data) => setExpertise(data));
  }, []);

  const [familiar, setFamiliar] = useState([]);

  useEffect(() => {
    fetch("familiar.json")
      .then((res) => res.json())
      .then((data) => setFamiliar(data));
  }, []);

  const [tools, setTools] = useState([]);

  useEffect(() => {
    fetch("tools.json")
      .then((res) => res.json())
      .then((data) => setTools(data));
  }, []);

  return (
    <div
      data-aos="fade-up"
      data-aos-duration="3000"
      className="container my-5"
      id="skills"
    >
      <h1 className="text-center fw-bold text-uppercase">Skills</h1>
      {/* Expertise */}
      <div>
        <h4 className="text-center">Expertise</h4>
        <div className="row my-3 g-3 justify-content-center">
          {expertise.map((ex) => (
            <div className="col-lg-2 col-md-6 col-4" key={ex.id}>
              <div className="text-center">
                <img src={ex.url} className="w-25" alt="" />
                <small>
                  <p>{ex.name}</p>
                </small>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Familiar */}
      <div className="mt-3">
        <h4 className="text-center">Familiar</h4>
        <div className="row my-3 g-3 justify-content-center">
          {familiar.map((fam) => (
            <div className="col-lg-2 col-md-6 col-4" key={fam.id}>
              <div className="text-center">
                <img src={fam.url} className="w-25" alt="" />
                <small>
                  <p>{fam.name}</p>
                </small>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Tools */}
      <div className="mt-3">
        <h4 className="text-center">Tools</h4>
        <div className="row my-3 g-3 justify-content-center">
          {tools.map((tool) => (
            <div className="col-lg-2 col-md-6 col-4" key={tool.id}>
              <div className="text-center">
                <img src={tool.url} className="w-25" alt="" />
                <small>
                  <p>{tool.name}</p>
                </small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
